import React from "react";

const CalendarIcon = ({ width }) => {
  return (
    <svg
      width={width}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      fill='#000000'
    >
      <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {" "}
        <path
          style={{ fill: "#E2E7F0" }}
          d='M0,144v304c0,17.672,14.328,32,32,32h384l96-96V144H0z'
        ></path>{" "}
        <path
          style={{ fill: "#F04B4D" }}
          d='M512,80c0-8.84-7.16-16-16-16H16C7.16,64,0,71.16,0,80v64h512V80z'
        ></path>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M184,208h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C176,211.584,179.584,208,184,208z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M248,208h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C240,211.584,243.584,208,248,208z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M312,208h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C304,211.584,307.584,208,312,208z'
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#99B5CD" }}
            d='M376,208h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C368,211.584,371.584,208,376,208z'
          ></path>{" "}
          <path
            style={{ fill: "#99B5CD" }}
            d='M440,208h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C432,211.584,435.584,208,440,208z'
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M56,264h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8H56c-4.416,0-8-3.584-8-8v-16 C48,267.584,51.584,264,56,264z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M120,264h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C112,267.584,115.584,264,120,264z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M184,264h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C176,267.584,179.584,264,184,264z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M248,264h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C240,267.584,243.584,264,248,264z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M312,264h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C304,267.584,307.584,264,312,264z'
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#99B5CD" }}
            d='M376,264h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C368,267.584,371.584,264,376,264z'
          ></path>{" "}
          <path
            style={{ fill: "#99B5CD" }}
            d='M440,264h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C432,267.584,435.584,264,440,264z'
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M56,320h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8H56c-4.416,0-8-3.584-8-8v-16 C48,323.584,51.584,320,56,320z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M120,320h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C112,323.584,115.584,320,120,320z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M184,320h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C176,323.584,179.584,320,184,320z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M248,320h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C240,323.584,243.584,320,248,320z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M312,320h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C304,323.584,307.584,320,312,320z'
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#99B5CD" }}
            d='M376,320h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C368,323.584,371.584,320,376,320z'
          ></path>{" "}
          <path
            style={{ fill: "#99B5CD" }}
            d='M440,320h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C432,323.584,435.584,320,440,320z'
          ></path>{" "}
        </g>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M56,376h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8H56c-4.416,0-8-3.584-8-8v-16 C48,379.584,51.584,376,56,376z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M120,376h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C112,379.584,115.584,376,120,376z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M184,376h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C176,379.584,179.584,376,184,376z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M248,376h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C240,379.584,243.584,376,248,376z'
          ></path>{" "}
          <path
            style={{ fill: "#B0C4D9" }}
            d='M312,376h16c4.416,0,8,3.584,8,8v16c0,4.416-3.584,8-8,8h-16c-4.416,0-8-3.584-8-8v-16 C304,379.584,307.584,376,312,376z'
          ></path>{" "}
        </g>{" "}
        <path
          style={{ fill: "#9DACBA" }}
          d='M416,416v64l96-96h-64C430.328,384,416,398.328,416,416z'
        ></path>{" "}
        <g>
          {" "}
          <path
            style={{ fill: "#C9D5E3" }}
            d='M377.36,454.64c-6.008,6-14.152,9.368-22.64,9.36H48c-8.84,0-16,7.16-16,16h384v-64L377.36,454.64z'
          ></path>{" "}
          <path
            style={{ fill: "#C9D5E3" }}
            d='M0,144c0,8.84,7.16,16,16,16h472c4.416,0,8,3.584,8,8v216h16V144H0z'
          ></path>{" "}
        </g>{" "}
        <circle style={{ fill: "#C61C31" }} cx='256' cy='96' r='24'></circle>{" "}
        <path
          style={{ fill: "#B0C4D9" }}
          d='M256,32L256,32c8.84,0,16,7.16,16,16v40c0,8.84-7.16,16-16,16l0,0c-8.84,0-16-7.16-16-16V48 C240,39.16,247.16,32,256,32z'
        ></path>{" "}
        <path
          style={{ fill: "#99B5CD" }}
          d='M272,88V48c0-4.416-3.584-8-8-8s-8,3.584-8,8v56C264.84,104,272,96.84,272,88z'
        ></path>{" "}
        <circle style={{ fill: "#C61C31" }} cx='112' cy='96' r='24'></circle>{" "}
        <path
          style={{ fill: "#B0C4D9" }}
          d='M112,32L112,32c8.84,0,16,7.16,16,16v40c0,8.84-7.16,16-16,16l0,0c-8.84,0-16-7.16-16-16V48 C96,39.16,103.16,32,112,32z'
        ></path>{" "}
        <path
          style={{ fill: "#99B5CD" }}
          d='M128,88V48c0-4.416-3.584-8-8-8s-8,3.584-8,8v56C120.84,104,128,96.84,128,88z'
        ></path>{" "}
        <circle style={{ fill: "#C61C31" }} cx='400' cy='96' r='24'></circle>{" "}
        <path
          style={{ fill: "#B0C4D9" }}
          d='M400,32L400,32c8.84,0,16,7.16,16,16v40c0,8.84-7.16,16-16,16l0,0c-8.84,0-16-7.16-16-16V48 C384,39.16,391.16,32,400,32z'
        ></path>{" "}
        <path
          style={{ fill: "#99B5CD" }}
          d='M416,88V48c0-4.416-3.584-8-8-8s-8,3.584-8,8v56C408.84,104,416,96.84,416,88z'
        ></path>{" "}
      </g>
    </svg>
  );
};

export default CalendarIcon;
